
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-d43v8n",
"minContentWidth": "--awsui-min-content-width-d43v8n",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-d43v8n",
"contentGapLeft": "--awsui-content-gap-left-d43v8n",
"contentGapRight": "--awsui-content-gap-right-d43v8n",
"contentHeight": "--awsui-content-height-d43v8n",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-d43v8n",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-d43v8n",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-d43v8n",
"defaultMaxContentWidth": "--awsui-default-max-content-width-d43v8n",
"defaultMinContentWidth": "--awsui-default-min-content-width-d43v8n",
"drawerSize": "--awsui-drawer-size-d43v8n",
"drawerMinSize": "--awsui-drawer-min-size-d43v8n",
"bottomDrawerSize": "--awsui-bottom-drawer-size-d43v8n",
"footerHeight": "--awsui-footer-height-d43v8n",
"headerGap": "--awsui-header-gap-d43v8n",
"headerHeight": "--awsui-header-height-d43v8n",
"layoutWidth": "--awsui-layout-width-d43v8n",
"mainGap": "--awsui-main-gap-d43v8n",
"mainOffsetLeft": "--awsui-main-offset-left-d43v8n",
"mainTemplateRows": "--awsui-main-template-rows-d43v8n",
"mobileBarHeight": "--awsui-mobile-bar-height-d43v8n",
"notificationsHeight": "--awsui-notifications-height-d43v8n",
"offsetTop": "--awsui-offset-top-d43v8n",
"overlapHeight": "--awsui-overlap-height-d43v8n",
"navigationWidth": "--awsui-navigation-width-d43v8n",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-d43v8n",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-d43v8n",
"splitPanelHeight": "--awsui-split-panel-height-d43v8n",
"splitPanelMinWidth": "--awsui-split-panel-min-width-d43v8n",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-d43v8n",
"toolsMaxWidth": "--awsui-tools-max-width-d43v8n",
"toolsWidth": "--awsui-tools-width-d43v8n",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-d43v8n",
"contentScrollMargin": "--awsui-content-scroll-margin-d43v8n",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-d43v8n",
"flashbarStackIndex": "--awsui-flashbar-stack-index-d43v8n",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-d43v8n",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-d43v8n",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-d43v8n",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-d43v8n",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-d43v8n",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-d43v8n",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-d43v8n",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-d43v8n",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-d43v8n",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-d43v8n",
"sliderLabelCount": "--awsui-slider-label-count-d43v8n",
"sliderTickCount": "--awsui-slider-tick-count-d43v8n",
"sliderReferenceColumn": "--awsui-slider-reference-column-d43v8n",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-d43v8n",
"sliderMaxStart": "--awsui-slider-max-start-d43v8n",
"sliderMinEnd": "--awsui-slider-min-end-d43v8n",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-d43v8n",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-d43v8n",
"togglesLeftWidth": "--awsui-toggles-left-width-d43v8n",
"togglesRightWidth": "--awsui-toggles-right-width-d43v8n",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-d43v8n",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-d43v8n",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-d43v8n",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-d43v8n",
"styleBackgroundActive": "--awsui-style-background-active-d43v8n",
"styleBackgroundDefault": "--awsui-style-background-default-d43v8n",
"styleBackgroundDisabled": "--awsui-style-background-disabled-d43v8n",
"styleBackgroundHover": "--awsui-style-background-hover-d43v8n",
"styleBorderColorActive": "--awsui-style-border-color-active-d43v8n",
"styleBorderColorDefault": "--awsui-style-border-color-default-d43v8n",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-d43v8n",
"styleBorderColorHover": "--awsui-style-border-color-hover-d43v8n",
"styleColorActive": "--awsui-style-color-active-d43v8n",
"styleColorDefault": "--awsui-style-color-default-d43v8n",
"styleColorDisabled": "--awsui-style-color-disabled-d43v8n",
"styleColorHover": "--awsui-style-color-hover-d43v8n",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-d43v8n",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-d43v8n",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-d43v8n",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-d43v8n",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-d43v8n",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-d43v8n",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-d43v8n",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-d43v8n",
"styleBackgroundReadonly": "--awsui-style-background-readonly-d43v8n",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-d43v8n",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-d43v8n",
"styleColorReadonly": "--awsui-style-color-readonly-d43v8n",
"styleBackgroundFocus": "--awsui-style-background-focus-d43v8n",
"styleBorderColorFocus": "--awsui-style-border-color-focus-d43v8n",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-d43v8n",
"styleColorFocus": "--awsui-style-color-focus-d43v8n",
"stylePlaceholderColor": "--awsui-style-placeholder-color-d43v8n",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-d43v8n",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-d43v8n",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-d43v8n",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-d43v8n",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-d43v8n",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-d43v8n",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-d43v8n",
"alertIconColor": "--awsui-alert-icon-color-d43v8n",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-d43v8n",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-d43v8n",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-d43v8n",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-d43v8n",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-d43v8n",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-d43v8n",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-d43v8n",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-d43v8n",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-d43v8n",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-d43v8n",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-d43v8n",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-d43v8n",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-d43v8n",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-d43v8n",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-d43v8n",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-d43v8n",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-d43v8n",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-d43v8n",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-d43v8n",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-d43v8n",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-d43v8n",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-d43v8n",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-d43v8n",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-d43v8n",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-d43v8n",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-d43v8n",
"progressBarHeight": "--awsui-progress-bar-height-d43v8n",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-d43v8n",
      };
      export default customCSSPropertiesMap;
    